import React, { useContext } from 'react';
import { Linking, StyleSheet, View } from 'react-native';
import { Button } from '@rneui/themed';
import FontAwesome5 from '@expo/vector-icons/FontAwesome5';
import PropTypes from 'prop-types';
import CdnImage from '../common/CdnImage';
import { H3, H4, H5 } from '../text';
import AppContext from '../../contexts/App';
import { fetchPage } from '../../common/Api';
import LayoutContext from '../../contexts/Layout';
import Utils from '../../common/Utils';

const MinistryGrid = ({ followContentLink, hideLink, ministries, ministryGroup, nodeTypeAlias = 'MinistryGrid', width, hardWidth }) => {
    const { dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);
    const flexDirection = layout.device.isMobile || layout.device.isTablet ? 'column' : 'row';
    const imageWidth = layout.device.isMobile || layout.device.isTablet ? hardWidth : Math.floor(hardWidth * 0.3);
    const textWidth = layout.device.isMobile || layout.device.isTablet ? undefined : Math.floor(hardWidth * 0.7);

    const filteredMinistries = ministries.filter(ministry => {
        const atMinistry = ministry?.ministryGroup;
        let include = false;

        ministryGroup.forEach(filter => {
            if (atMinistry && atMinistry.includes(filter)) {
                include = true;
            }
        });

        return include;
    });

    const renderMinistry = ministry => {
        if (!ministry) {
            return null;
        }

        const handlePress = async isCTA => {
            if (isCTA) {
                if (ministry.ctaLink.isExternal) {
                    Linking.openURL(ministry.ctaLink.externalUrl);
                } else {
                    if (ministry.ctaLinkInternalKey) {
                        await followContentLink(ministry.ctaLink.isExternal, ministry.ctaLink.internalKey, ministry.ctaLink.externalUrl);
                    } else {
                        await fetchPage(dispatch, Utils.cleanupInternalUrl(ministry.rootPath));
                    }
                }
            } else {
                await fetchPage(dispatch, Utils.cleanupInternalUrl(ministry.rootPath));
            }
        };

        return (
            <View key={`ministry-${ministry.id}`} style={{ borderBottomColor: '#8897a2', borderBottomWidth: StyleSheet.hairlineWidth, flexDirection: flexDirection }}>
                <CdnImage uri={ministry.gridImage.cdnImagePath} width={imageWidth} style={{ width: imageWidth }} />
                <View
                    style={{
                        marginVertical: Math.floor(layout.styleGuide.spacer2 * 2),
                        marginHorizontal: layout.device.isMobile || layout.device.isTablet ? layout.styleGuide.spacer2 : Math.floor(layout.styleGuide.spacer2 * 3),
                        width: textWidth
                    }}
                    dataSet={{
                        spacerBottom: `StyleGuide.Spacer2*2(${Math.floor(layout.styleGuide.spacer2 * 2)})`,
                        spacerleft: `StyleGuide.Spacer2*3(${Math.floor(layout.styleGuide.spacer2 * 3)})`,
                        spacerRight: `StyleGuide.Spacer2*3(${Math.floor(layout.styleGuide.spacer2 * 3)})`,
                        spacerTop: `StyleGuide.Spacer2*2(${Math.floor(layout.styleGuide.spacer2 * 2)})`
                    }}
                >
                    <H3
                        style={{ marginBottom: layout.styleGuide.spacer3 }}
                        text={ministry.ministryName}
                        dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}
                    />
                    <View style={{ marginBottom: layout.styleGuide.spacer3, maxWidth: '85%' }} dataSet={{ spacerBottom: `StyleGuide.Spacer3(${layout.styleGuide.spacer3})` }}>
                        {!ministry.gridDescription && <H4 style={{ color: '#7f868b' }} text='No Details' />}
                        {!!ministry.gridDescription && <H4 numberOfLines={20} style={{ color: '#7f868b' }} text={ministry.gridDescription} />}
                    </View>
                    <View>
                        <Button
                            buttonStyle={{ paddingLeft: 0 }}
                            containerStyle={{ flexDirection: 'row', justifyContent: 'flex-start' }}
                            icon={<FontAwesome5 color='#153d6e' name='chevron-circle-right' size={20} style={{ marginLeft: 5 }} />}
                            iconRight={true}
                            onPress={() => handlePress(false)}
                            title={<H5 style={{ color: '#153d6e' }} text='Visit Ministry Page' />}
                            type='clear'
                        />
                        {!hideLink && !!ministry.ctaLinkText && (!!ministry.ctaLink.internalKey || !!ministry.ctaLink.externalUrl) && (
                            <Button
                                containerStyle={{ flexDirection: 'row', justifyContent: 'flex-start' }}
                                icon={<FontAwesome5 color='#153d6e' name='chevron-circle-right' size={20} style={{ marginLeft: 5 }} />}
                                iconRight={true}
                                onPress={() => handlePress(true)}
                                title={<H5 style={{ color: '#153d6e' }} text={ministry.ctaLinkText} />}
                                type='clear'
                            />
                        )}
                    </View>
                </View>
            </View>
        );
    };

    if (!ministries) {
        return null;
    }

    return (
        <View dataSet={{ umbracoComponentName: nodeTypeAlias }}>
            {filteredMinistries.map(ministry => {
                return renderMinistry(ministry);
            })}
        </View>
    );
};

MinistryGrid.propTypes = {
    hideLink: PropTypes.bool,
    id: PropTypes.string,
    ministryGroup: PropTypes.array,
    references: PropTypes.object
};

export default MinistryGrid;
